import React from 'react'
import { Panel, Container, Button, Label, Toolbar } from '@sencha/ext-modern'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetContract } from 'tyan/reducers/actions'
import 'tyan/css/DetalApproval.css';
import TreeListView from 'tyan/components/TreeListView'
import { showFile, getFileIcon } from 'tyan/public/index'

Ext.require('Ext.MessageBox')
const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		padding: "10px",
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		padding: "10px",
		width: "100%",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
}
class DetailContract extends React.Component {
	state = {
		contract: null,
		errorMessage: null,
		contractMessage: null
	}

	componentDidMount() {
		const { doGetContract, match: { params: { type, contractID } } } = this.props
		doGetContract({
			contractType: type,
			contractID,
			onEnd: ({ contract, errorMessage }) => {
				this.setState({ contract, errorMessage })
			}
		})
	}


	handleBack = () => {
		const { history, match: { params: { source } } } = this.props
		history.goBack()

	}


	showContract = contract => {
		return (
			<Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
				{contract && contract.fields.map((item, index) => {
					switch (item.type) {
						case "attachment":
							return (
								<Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
									<Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
									<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
								</ Container>)
						case "tree":
							return (
								<TreeListView key={item.name} data={item.children} />)
						case "logs":
							return (
								<Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									{item.list && item.list.map((o, i) => (
										<Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
									))}
								</Container>
							)
						case "attachmentList":
							return (
								<Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
									<Label cls="label" key={index} html={item.name + '：'} />
									<Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
										{item.list && item.list.map((o, i) => (
											<Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
												<Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
											</ Container>
										)
										)}
									</ Container>
								</Container>
							)
						default:
							return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" />)
					}
				})}

				<Container layout={{ type: "hbox", pack: "space-between" }} margin="20 0 0 0" >
					<Label cls="label" style={{ backgroundColor: '#c57f5e', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'待分工'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: 'SteelBlue', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'待排工'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: 'Yellow', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'待检测'} padding="0 0 0 5" />
				</Container>
				<Container layout={{ type: "hbox", pack: "space-between" }} margin="5 0 0 0" >
					<Label cls="label" style={{ backgroundColor: 'MediumBlue', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'检测中'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: 'Lime', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'校核中'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: 'DarkOrchid', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'已检测'} padding="0 0 0 5" />
				</Container>
				<Container layout={{ type: "hbox", pack: "space-between" }} margin="5 0 0 0" >
					<Label cls="label" style={{ backgroundColor: 'red', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'报告编制'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: '#776f06', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'报告审核中'} padding="0 0 0 5" />
					<Label cls="label" style={{ backgroundColor: 'Salmon', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'报告批准中'} padding="0 0 0 5" />
				</Container>
				<Container layout={{ type: "hbox", pack: "space-between" }} margin="5 0 0 0" >
					<Label cls="label" style={{ backgroundColor: '#09ccf9', width: '25px', height: '20px' }} />
					<Label cls="label" style={{ width: '80px', lineHeight: '20px' }} html={'报告已批准'} padding="0 0 0 5" />
				</Container>
			</ Container>
		)
	}

	render() {
		const { contract, errorMessage, contractMessage } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!contract) {
			return <Message text="数据加载中..." />
		}
		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}

		return (
			<Panel shadow layout="vbox" {...panelProps}>
				<Toolbar title={'合同详情'} shadow={false} docked="top" />
				<Container layout="vbox" flex={4} scrollable style={style.outer}>
					{this.showContract(contract)}
				</Container>
				<Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
					<Button ui="action raised" text={'返回'} margin="5" handler={this.handleBack} />
				</Toolbar>
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})

export default compose(
	connect(mapStateToProps, { doGetContract })
)(DetailContract)